"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeJSONStringify = exports.getConnectionType = exports.getBrowserType = exports.getUserToken = exports.getCookieUser = void 0;
var js_cookie_1 = __importDefault(require("../third/js.cookie"));
/**
 * 目前没有统一维护的 utils 的私有包，待迁移
 */
var hosts_1 = require("./hosts");
var getCookie = function (name) {
    if (name) {
        try {
            return js_cookie_1.default.get(name);
        }
        catch (e) {
            return null;
        }
    }
    else {
        return js_cookie_1.default.get();
    }
};
function getUrlParam(key, originUrl) {
    var reg = new RegExp("(^|&)".concat(key).concat("=([^&]*)(&|$)"), "i");
    var url = originUrl ? originUrl.toString() : window.location.href;
    var index = url.indexOf("?");
    var tmpUrl = url.substr(index + 1);
    if (tmpUrl.indexOf("?") !== -1) {
        return getUrlParam(key, tmpUrl);
    }
    var result = tmpUrl.match(reg);
    if (result != null) {
        return unescape(result[2]);
    }
    return "";
}
/**
 * 仅前台使用！
 * 获取cookie中User,返回token和userId
 * @returns
 */
function getCookieUser() {
    var userId = 0;
    var token = "";
    var query = ["token", "ewt_user", "user"]; // userId 读取cookie标识位，准确性按数组顺序执行
    // 优先从cookie读取token信息
    for (var _i = 0, query_1 = query; _i < query_1.length; _i++) {
        var value = query_1[_i];
        var temp = getCookie(value);
        if (temp) {
            token = temp;
            break;
        }
    }
    if (!token)
        token = getUrlParam("token", location.search); // webview 补偿从url读取token
    // 如果取得的token中带有tk=字样，则代表从ewt_user或user中获取，需要进行再次截取处理，直到正常规则token
    if (token.match("tk="))
        token = getUrlParam("tk", token);
    if (!token) {
        token = "0-0"; // 最终依然没拿到token时使用默认token，如果走接口验证会被网关告知失效
    }
    userId = Number(token.split("-")[0]) || 0;
    return {
        userId: userId,
        token: token,
    };
}
exports.getCookieUser = getCookieUser;
/**
 * 前后台通用，获取用户token
 */
function getUserToken() {
    if (!hosts_1.hostInfo.isFront) {
        return getCookie(hosts_1.hostInfo.isCPS ? "CPS_Token" : "Admin-Token") || "";
    }
    return getCookieUser().token;
}
exports.getUserToken = getUserToken;
/**
 * 判断浏览器类型,不再判断ie6-9
 * @returns
 */
function getBrowserType() {
    var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1; // 判断是否Opera浏览器
    var isIE = "ActiveXObject" in window; // 判断是否IE浏览器
    var isEdge = userAgent.indexOf("Edg") > -1; // 判断是否IE的Edge浏览器
    var isFF = userAgent.indexOf("Firefox") > -1; // 判断是否Firefox浏览器
    var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1; // 判断是否Safari浏览器
    var isChrome = userAgent.indexOf("Chrome") > -1 &&
        userAgent.indexOf("Safari") > -1 &&
        !isEdge; // 判断Chrome浏览器
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var t = "$1";
        var Reg = RegExp[t];
        var fIEVersion = window.parseFloat(Reg);
        if (fIEVersion === 10) {
            return "IE10";
        }
        else if (userAgent.toLowerCase().match(/rv:([\d.]+)\) like gecko/)) {
            return "IE11";
        }
        else {
            return "IE".concat(fIEVersion);
        }
    }
    if (isEdge) {
        return "Edge";
    }
    if (isFF) {
        return "FF";
    }
    if (isOpera) {
        return "Opera";
    }
    if (isChrome) {
        return "Chrome";
    }
    if (isSafari) {
        return "Safari";
    }
    return "";
}
exports.getBrowserType = getBrowserType;
/**
 * 获取网络连接类型
 * @returns
 */
function getConnectionType() {
    var _a, _b;
    if ("connection" in navigator) {
        // 使用类型断言告诉 TypeScript navigator 中包含 connection 属性
        var nav = navigator;
        // 根据网络连接类型返回相应的值
        if ((_a = nav.connection) === null || _a === void 0 ? void 0 : _a.type) {
            return nav.connection.type;
        }
        else if ((_b = nav.connection) === null || _b === void 0 ? void 0 : _b.effectiveType) {
            return nav.connection.effectiveType;
        }
    }
    return undefined;
}
exports.getConnectionType = getConnectionType;
var safeJSONStringify = function (obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (e) {
        return "";
    }
};
exports.safeJSONStringify = safeJSONStringify;
